import styled from 'styled-components';
import { media } from '../../../../../helpers/breakpoints';
import { LinkButton } from '../../../../Toolkit/Button/LinkButton';

export const STrustedDealerPanel = styled.div`
  display: grid;
  // Layout to match CarSummary panel above
  grid-template-columns: 1fr;
  grid-column-gap: 40px;
  grid-row-gap: 16px;

  ${media.medium} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const TDPDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.S4};
`;

export const TDPInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.M16};
`;

export const DealerInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr 1px 1fr;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing.S12};

  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    padding-right: 0;
  }

  ${media.medium} {
    padding: 0 ${({ theme }) => theme.spacing.M16};
  }
`;
export const Divider = styled.div`
  height: auto;
  width: 1px;
  background: ${({ theme }) => theme.colors.GREY_LIGHT};
`;

export const Rating = styled(LinkButton)`
  display: flex;
  align-items: center;
  min-height: 24px;
  gap: ${({ theme }) => theme.spacing.S4};
`;

export const Subtitle = styled.div`
  ${({ theme }) => theme.fontSize.B12};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  color: ${({ theme }) => theme.colors.GREY_DARK};
  white-space: nowrap;
`;
